export default __webpack_public_path__ + "static/media/montain.81bf1a32.svg";